import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  rightAction: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 6,
    paddingBottom: 6
  },
  actionIcon: {
    fontSize: '20px',
    marginRight: 6
  },
  actionText: {
    whiteSpace: 'initial',
    textOverflow: 'initial'
  }
})

export default useStyles
